module.exports = __webpack_public_path__ + "img/portrait.3442c1fc.jpg";